module.exports = __webpack_public_path__ + "img/alchera-logo.ed96b4c8.svg";